// typeAbout.js
import React from "react";
import Typewriter from "typewriter-effect";

function Type2() {
  return (
    <Typewriter
      options={{
        strings: [
          "Software Engineer",
          "Aerospace Enjoyer",
          "Problem Solver",
          "React Specialist",
          "Constant Learner",
          "Excuses: 404 Not Found",
          "Leader of Teams",
          "Creative Thinker",
          "Car Enthusiast",
          "Music Fanatic",
          "Concert Goer",
          "Doggo Lover",
          "Restarting in...",
          "3",
          "2",
          "1",
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 55,
      }}
    />
  );
}

export default Type2;
